import HCategory from "./HCategory.js";
import HPerson from "./HPerson.js";
import HPunch from "./HPunch.js";
export default class HResult {
    ID = -1;
    Result = 0;
    Status = 0;
    PersonID = -1;
    static FromDB(r) {
        var o = new HResult();
        o.ID = r.ID;
        o.Result = r.Result;
        o.Status = parseInt(r.Status);
        o.PersonID = r.PersonID;
        return o;
    }

    ToDbValues() {
        var a = [];
        a.push(this.ID);
        a.push(this.Result);
        a.push(this.Status);
        a.push(this.PersonID);
        return a;
    }

}
export class HResultStatus {
    static get OK() { return 0; }
    static get NQ() { return 1; }
    static get DISQ() { return 2; }
    static get DNF() { return 3; }
    static get DNS() { return 4; }
    static get RUN() { return 5; }
    static get NOFF() { return 6; } //not official finish only before reading
}
export class HPersonResult {
    Category = new HCategory();
    Person = new HPerson();
    Result = new HResult();
    Finish = new HPunch();
    static sortByResult(a, b) {
        if (a.Result.Result < b.Result.Result) return -1;
        if (a.Result.Result > b.Result.Result) return 1;
        return 0;
    }
    static sortByStatusResult(a, b) {
        if (a.Result.Status < b.Result.Status) return -1;
        if (a.Result.Status > b.Result.Status) return 1;
        if (a.Result.Result < b.Result.Result) return -1;
        if (a.Result.Result > b.Result.Result) return 1;
        return 0;
    }
}